import React, { useEffect, useState } from 'react';
import { _ } from '_locales';
import { useHistory } from 'react-router-dom';
import cts from '_cts';
import apis from '_apis';
import { goToTop } from '_helpers';
import oneOf from '../DepoEvents_Components/helpers';

import { MoreLocationsList } from './components';
import { LoadingSpinner } from '../../../components';

const routes = {
  'event-list': (pathname) => ((pathname.includes('/wgw')) ? '/wgw/event-details' : '/cal/event-details'),
  'depo-list': (pathname) => ((pathname.includes('/wgw')) ? '/wgw/depo-details' : '/cal/depo-details'),
  'drop-event-list': (pathname) => ((pathname.includes('/wgw')) ? '/wgw/event-details' : '/cal/event-details'),
};

/* Define endpoints by the name of events */
const endpoints = ({
  projectId, districtId, matId, location, lang
}) => ({
  'event-list': apis.getEventsApi(projectId, districtId, matId, lang),
  'depo-list': apis.getDeposApi(projectId, districtId, matId, location, lang),
  'drop-event-list': apis.getDropEventList(projectId, districtId, matId, lang),
});

/**
 * useEvents hook
 * This hooks is used to get list of events
 * @param {number} matId
 */
const useDepoEvents = (projectId, districtId, matId, location, kind, lang) => {
  const [list, setList] = useState({});
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getDepoEvents = async () => {
      try {
        setLoading(true);
        const { data, status } = await cts('get', endpoints({
          projectId, districtId, matId, location, lang
        })[kind]);

        if (
          !data
          && status !== 200
        ) throw new Error('Error getting depot list.');

        setList(data.content.response);

        return undefined;
      } catch (e) {
        setError(true);
        return Promise.reject(e.message);
      } finally {
        setLoading(false);
      }
    };
    getDepoEvents();
  }, [matId, location, kind, projectId, districtId, lang]);

  return {
    list,
    error,
    loading
  };
};

const DepoEventList = ({
  plugin, config, props
}) => {
  const history = useHistory();
  const { projectId } = plugin;
  const { selectedLang, districtId } = config;
  const { location } = props;
  const { state, pathname } = location; // material state

  /**
   * Get list hook
   */
  const {
    list,
    loading,
    error
  } = useDepoEvents(projectId, districtId, state.depoEventId, '', state.type, selectedLang);

  /**
   * Normalize List
   */
  const normaList = 'results' in list && list.results.map((item, i) => {
    const id = oneOf(['drop_event_id', 'drop_depot_id'], item);
    const name = oneOf(['depot_nm', 'event_nm'], item);

    return ({
      key: `depo-event-${id}-${i}`,
      id,
      name,
      ...item
    });
  });

  // if there is only one item redirect to details page.
  if (normaList && normaList.length === 1) {
    goToTop();
    const depoEventId = (state.type.includes('event'))
      ? `${normaList[0].id}-${normaList[0].drop_event_loc_id}` : normaList[0].id;
    const depoEventKind = (state.type.includes('event')) ? 'event-details' : 'depo-details';
    history.push(routes[state.type](pathname), { id: depoEventId, depoEventKind, normaList });
  }

  if (error) return <p>Error loading data...</p>;

  return (
    <>
      {loading
        ? <LoadingSpinner height={500} />
        : (
          <MoreLocationsList
            state={state}
            normaList={normaList}
            pathname={pathname}
          />
        )}
    </>
  );
};

export default DepoEventList;
